// Shared presentational components. Modules import from here (or their own
// subtree) — never from each other.
export { cn } from "./cn";
export { Button, buttonVariants, type ButtonProps } from "./Button";
export { Input, type InputProps } from "./Input";
export { PasswordInput } from "./PasswordInput";
export { Select, type SelectProps } from "./Select";
export { Card, cardVariants, type CardProps } from "./Card";
export { Alert, alertVariants, type AlertProps } from "./Alert";
export { StatusBadge } from "./StatusBadge";
export { RoleBadge } from "./RoleBadge";
export { Skeleton, TableSkeleton, StatCardSkeleton } from "./Skeleton";
export { EmptyState, type EmptyStateProps } from "./EmptyState";
export {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "./Dialog";
export { ConfirmDialog, type ConfirmDialogProps } from "./ConfirmDialog";
export { DataTable, type ColumnDef, type DataTableProps } from "./DataTable";
export {
  BRAND_ATTRIBUTE,
  BRANDS,
  DEFAULT_BRAND,
  applyBrand,
  currentBrand,
  type BrandId,
  type ThemeId,
} from "./tokens";
export { brandProfile, currentBrandProfile, type BrandProfile } from "./brand";
export { BrandLogo } from "./BrandLogo";
export { useCurrentBrand } from "./useCurrentBrand";
export { ServedBrandContext, useServedBrand } from "./servedBrand";
export {
  THEME_MODES,
  applyThemeMode,
  readStoredThemeMode,
  resolveTheme,
  type ThemeMode,
} from "./theme";
export { ThemeProvider, useThemeMode } from "./ThemeProvider";
export { ThemeToggle } from "./ThemeToggle";
export { SiteFooter } from "./SiteFooter";
